import { UUID } from "../../../utils/typeDefinitions";
import IBimVisualizerApiProvider from "../IBimVisualizerApiProvider";

import AppDataProvider from "./AppDataProvider";
import IGbContext from "../../../interfaces/IGbContext";
import ApiCoreDocumentProvider from "../../documentProvider/ApiCoreDocumentProvider";
import User from "../../../model/User";
import IDocumentProvider from "../../documentProvider/IDocumentProvider";
import { RoomNoteSaveResult } from "../../coreApi/RoomNoteSaveResult";
import ICoreApiProvider from "../../coreApi/ICoreApiProvider";
import ICoreRoom from "../../../interfaces/ICoreRoom";

// CoreAPI rooms/update checks no right, so the client gates note editing with the right CoreClient effectively uses.
// Switch to a dedicated right (e.g. room:comment:update) once CoreAPI has one.
const ROOM_NOTES_UPDATE_RIGHT = "coreclient:apartments";

class GbContextAppDataProvider extends AppDataProvider  {
    gbContext: IGbContext;
    coreApiProvider: ICoreApiProvider;

    constructor(apiProvider: IBimVisualizerApiProvider, coreApiProvider: ICoreApiProvider, gbContext: IGbContext, docProvider: IDocumentProvider) {
        super(apiProvider, docProvider);
        this.coreApiProvider = coreApiProvider;
        this.gbContext = gbContext;
    }

        // Load spatial structure model
    loadRootProduct = async () => {
        const result = await this.apiProvider.getApartmentModelByGbContext(this.gbContext);
        return result;
    }

    getCurrentUser = async (): Promise<User | null> => {
        return await this.apiProvider.getCurrentUser(this.gbContext);
    }

    canEditRoomNotes = async (): Promise<boolean> => {
        return await this.coreApiProvider.hasUserRight(this.gbContext, ROOM_NOTES_UPDATE_RIGHT);
    }

    loadRoomNotes = async (): Promise<ICoreRoom[]> => {
        return await this.coreApiProvider.getApartmentRooms(this.gbContext) ?? [];
    }

    updateRoomNote = async (roomId: number, notes: string | null): Promise<RoomNoteSaveResult> => {
        return await this.coreApiProvider.updateRoomComment(this.gbContext, roomId, notes);
    }
}

export default GbContextAppDataProvider;